<template>
  <div>
    <PrimaryButton @click.native="openDialog" light shrink>
      Edit
      <v-icon class="ml-3">mdi-pencil</v-icon>
    </PrimaryButton>
    <EditOfferGroupsDialog @close="closeDialog" v-if="isOpen" />
  </div>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import EditOfferGroupsDialog from "@/views/offers/dialogs/EditOfferGroupsDialog";

export default {
  components: {
    PrimaryButton,
    EditOfferGroupsDialog
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
